import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Titulo from '../../components/Texto/Titulo';
import Loading from '../../components/Loading';
import { verifyAdmin } from '../../utils/verify-admin';
import * as actions from '../../actions/usuariosAdmin';

const ROTULO_PERMISSAO = {
	admin: 'Administrador',
	mkt: 'Marketing',
	owner: 'Proprietário',
	scanner: 'Leitor de QR',
	developer: 'Desenvolvedor'
};

function formatPermissoes(permissao){
	if(!Array.isArray(permissao)) return '';
	return permissao.map((p) => ROTULO_PERMISSAO[p] || p).join(', ');
}

/** Único usuário com owner na loja — não pode ser excluído (API também bloqueia). */
function ehUnicoProprietario(row, rows){
	if(!(row.permissao || []).includes('owner')) return false;
	const qtd = rows.filter((r) => (r.permissao || []).includes('owner')).length;
	return qtd === 1;
}

class Usuarios extends Component {

	state = {
		refreshing: false,
		lista: null
	}

	componentDidMount(){
		this.carregar();
	}

	carregar = () => {
		this.props.getUsuariosAdmin().then((data) => {
			if(this._ehErro(data)){
				this.setState({ lista: [] });
				return;
			}
			this.setState({ lista: data.usuarios || [] });
		});
	}

	_ehErro = (data) => {
		if(!data) return true;
		if(data.status && data.message){
			window.alert(data.message);
			return true;
		}
		if(data.errors){
			window.alert(typeof data.errors === 'string' ? data.errors : 'Erro ao processar.');
			return true;
		}
		return false;
	}

	refreshList = () => {
		this.setState({ refreshing: true });
		this.carregar();
		const timer = setTimeout(() => {
			this.setState({ refreshing: false });
			clearTimeout(timer);
		}, 1200);
	}

	remover = (row) => {
		if(!window.confirm(`Remover o usuário "${row.nome}"? Esta ação não pode ser desfeita.`)) return;
		this.props.deleteUsuarioAdmin(row._id).then((data) => {
			if(this._ehErro(data)) return;
			this.carregar();
		});
	}

	render(){
		const { admin } = this.props;
		const { lista, refreshing } = this.state;

		if(!admin) return <Loading />;

		if(!verifyAdmin(admin, 'owner')){
			return null;
		}

		const rows = Array.isArray(lista) ? lista : [];

		return (
			<div className="Categories container-centered UsuariosPage">
				<div className="Page-Title">
					<Titulo tipo="h1" titulo="Usuários do painel"/>
					<div className="actionsTollBar">
						<Link to="/usuarios/novo" title="Novo usuário">
							<div className="btnIcon plus" style={{ marginLeft: 0 }}></div>
						</Link>
					</div>
				</div>

				<div className={`Table Entregadores${refreshing ? ' refreshing' : ''}`}>
					<div className="head">
						<div>Nome</div>
						<div>E-mail</div>
						<div>Permissões</div>
						<div>Ações</div>
						<button type="button" className="refreshButton" onClick={this.refreshList}>
							<i className="fas fa-redo"></i>
						</button>
					</div>
					<div className="body">
						{ rows.length === 0 ? (
							<div className="item entregadoresTable-empty">
								<span>Nenhum usuário cadastrado.</span>
							</div>
						) : rows.map((row) => (
							<div key={row._id} className="item">
								<span>{row.nome}</span>
								<span>{row.email}</span>
								<span>{formatPermissoes(row.permissao)}</span>
								<span className="entregadoresTable-actions">
									<Link className="entregadoresTable-linkEdit" to={`/usuarios/${row._id}/edit`}>Editar</Link>
									{ admin.email !== row.email && !ehUnicoProprietario(row, rows) && (
										<button type="button" className="danger" onClick={() => this.remover(row)}>Remover</button>
									) }
								</span>
							</div>
						)) }
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	admin: state.auth.usuario
});

export default connect(mapStateToProps, actions)(Usuarios);
